query scenariosQuery($scenarioFilter: ScenariosInput) {
  base {
    scenarios(filter: $scenarioFilter) {
      id
      name
      description
      status {
        id
        value
      }
      workspace {
        id
        code
        name
      }
    }
  }
}
